import { Component, OnInit ,Input, EventEmitter, Output } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import { Router } from '@angular/router';
import { PermissionService } from '../../../../services/permission.service';


@Component({
  selector: 'app-table-report-modify-settings',
  template: `
            <span *ngIf="showScheduleLink"><a class="status-link text-link" href="javascript:void(0);" (click) = "onScheduleClick()" >Schedule</a></span>`,
  styleUrls: ['./table-report-modify-settings.component.scss']
})
export class TableReportModifySettingsComponent implements OnInit {

  @Input() value : string | number;
  @Input() rowData : any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();
  @Output() reportclicked: EventEmitter<any> = new EventEmitter();

  showScheduleLink: boolean;

  constructor(
    private router: Router,
    private permissionService: PermissionService
  ) {}

  ngOnInit() {
    const url = this.router.url;
    const isEmailSavedScheduleReport = url.includes('analytics/saved-schedule-report');
    const isGrcsManageReports = url.includes('grcs/manage-reports');
    const isWaManageReports = url.includes('whatsapp/manage-reports');
    if (isEmailSavedScheduleReport) {
      this.showScheduleLink = this.permissionService.hasPermission('email', 'Reports', 'edit');
    } else if (isGrcsManageReports) {
      this.showScheduleLink = this.permissionService.hasPermission('rcs', 'Reports', 'edit');
    } else if (isWaManageReports) {
      this.showScheduleLink = this.permissionService.hasPermission('whatsapp', 'Reports', 'edit');
    } else {
      this.showScheduleLink = true;
    }
  }

  onScheduleClick() {
    this.rowData['click_type'] = 1;    // for schedule
    this.clicked.emit(this.rowData);
  }

  onReportClick( ){

    // this.rowData['click_type'] = 2;   // for report click
    this.reportclicked.emit(this.rowData);
  }

}
